import { put, takeLatest, call, spawn, all } from 'redux-saga/effects';
import { otpActions } from '../../../application/actions/otp';
import { loadingActions } from '../../../application/actions/ui_loaders';

import api from '../../api';

const apiOtp = api(process.env.REACT_APP_OTP_API);

export function* fetchOtp() {
  try {
    yield put(loadingActions.changeStatusLoadingFetchOtp({ isLoading: true }));

    const { data, error } = yield call(apiOtp.get, 'v1/solicitar');

    if (data)
      yield all([
        put(otpActions.fetchOtpSuccess(data)),
        put(loadingActions.changeStatusLoadingFetchOtp({ isLoading: false })),
      ]);
    else
      yield all([
        put(otpActions.fetchOtpError(error)),
        put(loadingActions.changeStatusLoadingFetchOtp({ isLoading: false })),
      ]);
  } catch (err) {
    yield all([
      put(otpActions.fetchOtpError({ code: 500, message: err })),
      put(loadingActions.changeStatusLoadingFetchOtp({ isLoading: false })),
    ]);
  }
}

export function* validateOtp(action) {
  try {
    yield put(loadingActions.changeStatusLoadingValidateOtp({ isLoading: true }));

    const { data, error } = yield call(apiOtp.post, 'v1/validar', action.payload);

    if (data)
      yield all([
        put(loadingActions.changeStatusLoadingValidateOtp({ isLoading: false })),
        put(otpActions.validateOtpSuccess(data)),
      ]);
    else
      yield all([
        put(loadingActions.changeStatusLoadingValidateOtp({ isLoading: false })),
        put(otpActions.validateOtpError(error)),
      ]);
  } catch (err) {
    yield all([
      put(otpActions.validateOtpError({ code: 500, message: err })),
      put(loadingActions.changeStatusLoadingValidateOtp({ isLoading: false })),
    ]);
  }
}

export function* watchValidateOtp() {
  yield takeLatest(otpActions.validateOtp.type, validateOtp);
}
export function* watchFetchOtp() {
  yield takeLatest(otpActions.fetchOtp.type, fetchOtp);
}
/* istanbul ignore next */
export default function* otpSaga() {
  yield spawn(watchFetchOtp);
  yield spawn(watchValidateOtp);
}
